import React, { createContext, useContext } from 'react';
import { ExtendedAuthContextType } from './auth/authContextTypes';
import { useAuthLogic } from './auth/useAuthLogic.tsx';
import { User } from './auth/types';

// Create context with default values
const AuthContext = createContext<ExtendedAuthContextType>({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  isLoggingOut: false,
  isAuthStable: false,
  login: async () => {},
  register: async () => {},
  logout: () => {},
  checkAuth: async () => false,
  updateNickname: async () => {},
  updateProfile: async () => {},
  createUserFromRegistrationRequest: async () => ({} as User),
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const authLogic = useAuthLogic();

  return (
    <AuthContext.Provider value={authLogic}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook to use auth context
export const useAuth = () => {
  const context = useContext(AuthContext);
  return context;
};

// Export types for convenience
export type { User, UserRole } from './auth/types';
